export default __webpack_public_path__ + "static/bg_graphics_poster-422787211e39df868d8560891ff5a490.webp";